export const CATEGORY_PAGE_EU_BUSINESSCARDS_STOCKOPTIONS =
  'category_page_eu_businesscards_stockoptions'

export const CATEGORY_PAGE_EU_CUSTOMSTICKERSINGLES_STOCKOPTIONS =
  'category_page_eu_customstickersingles_stockoptions'

export const CATEGORY_PAGE_CA_BUSINESSCARDS_STOCKOPTIONS =
  'category_page_ca_businesscards_stockoptions'

export const CPV3_AUTOMATED_RECOMMENDATION_EU = 'cpv3_automated_recommendation_eu'

export const CPV3_AUTOMATED_RECOMMENDATION_NA = 'cpv3_automated_recommendation_na'
